import { CalendarClock } from "lucide-react";
import { Input } from "@/components/ui/input";

/** Formats a Date object for a <input type="datetime-local"> value. */
export const toLocalInputValue = (d) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** Default = tomorrow at 7pm local (nice sane default for evening blasts). */
export const defaultScheduledFor = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  d.setHours(19, 0, 0, 0);
  return toLocalInputValue(d);
};

export const fmtScheduled = (iso) => {
  try {
    return new Date(iso).toLocaleString(undefined, {
      weekday: "short", month: "short", day: "numeric",
      hour: "numeric", minute: "2-digit",
    });
  } catch { return iso; }
};

/** Datetime-local field shown when mode === "schedule". */
export default function BroadcastScheduleField({ value, onChange }) {
  return (
    <div className="border-l-2 border-rose-500 pl-3 py-2 space-y-2">
      <label className="text-xs uppercase tracking-widest text-zinc-500 flex items-center gap-2">
        <CalendarClock size={14} /> Send at (your local time)
      </label>
      <Input
        type="datetime-local"
        value={value}
        min={toLocalInputValue(new Date(Date.now() + 60_000))}
        onChange={(e) => onChange(e.target.value)}
        className="bg-black/40 border-white/10 rounded-none py-5"
        data-testid="broadcast-scheduled-for"
      />
      <p className="text-[11px] text-zinc-500">
        Emails go out automatically at this time. You can cancel below anytime before then.
      </p>
    </div>
  );
}
